import { inject, InjectionToken } from '@angular/core';
import { OfflineSnapshotDatabase } from './offline-snapshot.database';
import type { StoredOfflineSnapshot } from './offline-snapshot.types';

export type OfflineSnapshotStore = {
  delete(key: string): Promise<void>;
  entries(): Promise<StoredOfflineSnapshot[]>;
  get(key: string): Promise<StoredOfflineSnapshot | null>;
  put(record: StoredOfflineSnapshot): Promise<void>;
};

export const OFFLINE_SNAPSHOT_STORE = new InjectionToken<OfflineSnapshotStore>(
  'OFFLINE_SNAPSHOT_STORE',
  {
    factory: () => inject(OfflineSnapshotDatabase),
    providedIn: 'root',
  },
);
